module.exports = __webpack_public_path__ + "static/media/person-placeholder.b9838bf7.jpg";